import { css, FlattenSimpleInterpolation } from 'styled-components';

interface IKOGMediaQueryProps {
  breakpoint: string;
  includeOrientation?: boolean;
  styles: FlattenSimpleInterpolation;
}
/**
 * Generates a conditional media query based on the provided breakpoint.
 *
 * @param {string} breakpoint (required) - The `max-width` value for the media query (e.g., '1200px' or breakpoint: theme.breakpoints.mobile).
 * @param {FlattenSimpleInterpolation} styles (required) - The CSS styles to be applied inside the media query.
 * @param {boolean} [includeOrientation=false] - If set to `true`, applies styles for both `portrait` and `landscape` orientations.
 *
 * @example
 * ${({ theme }) =>
 *   KOGMediaQuery({
 *     breakpoint: theme.breakpoints.desktop,
 *     styles: css`
 *       background: red;
 *     `
 *   })}
 */
export const KOGMediaQuery = ({
  breakpoint,
  includeOrientation,
  styles
}: IKOGMediaQueryProps) => {
  if (includeOrientation) {
    return css`
      @media (max-width: ${breakpoint}), (orientation: portrait) {
        ${styles}
      }
      @media (max-width: ${breakpoint}), (orientation: landscape) {
        ${styles}
      }
    `;
  }

  return css`
    @media (max-width: ${breakpoint}) {
      ${styles}
    }
  `;
};

export function mediaMobileLandscape(styles: FlattenSimpleInterpolation): FlattenSimpleInterpolation {
	return css`
		@media screen and (orientation: landscape) and (max-height: 500px) {
			${styles}
		}
	`;
}
